import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { SpotDetailUrlResponse } from "../models/spot-listing.model";

@Injectable()
export class FeaturedListingService {
  latamCountry = "";
  constructor(private http: HttpClient) {}

  private buildinglistingResource = `/buildinglisting`;

  async checkListingDetailRoute(id: number, lang?: string) {
    console.error(
      "checkListingDetailRoute is deprecated, use getSpotBuildingDetailURLFormat instead"
    );
    /*
    return await this.http
      .get(environment.apiURL + "/listings/" + id + "/detail/url-data/" + lang)
      .toPromise()
      .then((result: any) => {
        return result;
      });
      */
    return undefined;
  }

  getSpotBuildingDetailURLFormat(id: number, lang?: string) {
    const url =
      (this.latamCountry == "latamMx"
        ? environment.apiURLMX
        : this.latamCountry == "latamBr"
        ? environment.apiURLBR
        : "/api") +
      `${this.buildinglistingResource}/${id}/detail/url-data/${lang}`;

    return this.http
      .get<SpotDetailUrlResponse>(url, { observe: "response" })
      .pipe(
        map(val =>
          this.buildSpotDetailUrl(val.body.detailsURL, this.latamCountry)
        )
      );
  }

  /**
   * Absolute SPOT listing URL from the relative `detailsURL` the backend
   * returns. SPOT is a separate site, so the MX or BR SPOT host is prefixed.
   */
  buildSpotDetailUrl(detailsURL: string, latamCountry: string): string {
    const spotHost =
      latamCountry == "latamMx" ? environment.spotURLMx : environment.spotURL;
    return `${spotHost}/${detailsURL}`;
  }
}
